<template>
  <div class="bg_gray">
    <van-nav-bar :fixed="true"
      z-index="10"
      title="我的开票"
      right-text="申请开票"
      left-arrow
      @click-left="goPath('/mobile/center')"
      @click-right="goPath('/mobile/center/ticket/apply')"
    />
    <div class="container bg_gray" v-if="ticketList.data.length !== 0">
      <LoadList :pager="ticketList.pager"
                      v-model:loading="loading_data"
              @getPager="getinvoicePager">
        <van-cell-group v-for="(item, index) in ticketList.data" :key="index" class="list" @click="showInvoice(item)">
          <van-cell>
            <template #title>
              <span style="color:#666;">{{item.created_at}}</span>
            </template>
            <template #label>
              <div class="content">
                <div class="left">
                  <span v-if="item.type == 0" class="type">普通发票</span>
                  <span v-if="item.type == 1" class="type">专用发票</span>
                  <van-tag v-if="item.medium == 0" color="#999" text-color="#999" round plain type="primary">电子发票</van-tag>
                  <van-tag v-if="item.medium == 1" color="#999" text-color="#999" round plain type="primary">纸质发票</van-tag>
                </div>
                <div class="right">¥ {{item.money}}</div>
              </div>
            </template>
          </van-cell>
          <van-cell title="">
            <template #extra>
              <div class="text-right status">
                <span v-if="item.status == 0">待查看</span>
                <span v-if="item.status == 1">已取消</span>
                <span v-if="item.status == 2">开票中</span>
                <span v-if="item.status == 3">已寄送</span>
                <van-button v-if="item.status == 0"
                  @click.stop="updateInvoice(item)"
                  type="default">
                  修改
                </van-button>
                <van-button v-if="item.status == 0"
                  @click.stop="changesInvoice(item)"
                  type="default">
                  取消
                </van-button>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </LoadList>
    </div>
    <van-empty v-else description="暂无内容哦~" />

    <!-- 弹出框 -->
    <van-popup
      v-model:show="detailModal.visible"
      position="right"
      :style="{ width: '100%', height: '100%' }"
      @closed="initPopContent"
      class="sheet_common bg_gray">
      <div class="sheet_wrap">
        <van-nav-bar
          z-index="10"
          title="开票详情"
          right-text="取消申请"
          left-arrow
          @click-left="closeInvoice"
          @click-right="changeInvoices"
          v-if="detailModal.form.status == 0"
        />
        <van-nav-bar
          z-index="10"
          title="开票详情"
          left-arrow
          @click-left="closeInvoice"
          v-if="detailModal.form.status != 0"
        />
        <div class="sheet_content bg_gray">
          <van-cell-group>
            <van-cell title="申请信息" size="large" />
            <van-cell>
              <template #title>
                <div class="detail_content">
                  <p>
                    发票类型：
                    <span v-if="detailModal.form.type == 0 ">普通发票</span>
                    <span v-if="detailModal.form.type == 1 ">专用发票</span>
                  </p>
                  <p>
                    发票介质：
                    <span v-if="detailModal.form.medium == 0">电子发票</span>
                    <span v-if="detailModal.form.medium == 1">纸质发票</span>
                  </p>
                  <p>发票内容：培训费</p>
                  <p>发票金额：¥ {{detailModal.form.money}}</p>
                  <p>发票抬头：{{detailModal.form.title}}</p>
                  <p>公司名称：{{detailModal.form.company}}</p>
                  <!-- 默认隐藏信息 -->
                  <div v-if="detailModal.showApplyInfoAll">
                    <p>纳税人识别号：{{detailModal.form.taxpayer_num}}</p>
                    <p>纳税人地址：{{detailModal.form.taxpayer_addr}}</p>
                    <p>纳税人电话：{{detailModal.form.taxpayer_phone}}</p>
                    <p>开户行：{{detailModal.form.account_bank}}</p>
                    <p>开户行账号：{{detailModal.form.account_num}}</p>
                    <p v-if="(detailModal.form.type == 0) && (detailModal.form.medium == 0)">接收邮箱：{{detailModal.form.email_addr}}</p>
                    <p v-if="((detailModal.form.type == 0) && (detailModal.form.medium == 1)) || (detailModal.form.type == 1)">接收寄送地址：{{detailModal.form.post_addr_str}}</p>
                    <p v-if="((detailModal.form.type == 0) && (detailModal.form.medium == 1)) || (detailModal.form.type == 1)">收件人：{{detailModal.form.addressee}}</p>
                    <p v-if="((detailModal.form.type == 0) && (detailModal.form.medium == 1)) || (detailModal.form.type == 1)">收件人电话：{{detailModal.form.reci_phone}}</p>
                    <p>申请时间：{{detailModal.form.created_at}}</p>
                    <p>
                      申请状态：
                      <span v-if="detailModal.form.status == 0">待查看</span>
                      <span v-if="detailModal.form.status == 1">已取消</span>
                      <span v-if="detailModal.form.status == 2">开票中</span>
                      <span v-if="detailModal.form.status == 3">已寄送</span>
                    </p>
                    <p v-if="detailModal.form.medium == 1">快递公司：{{detailModal.form.express_company}}</p>
                    <p v-if="detailModal.form.medium == 1">快递单号：{{detailModal.form.express_num}}</p>
                    <p>寄送操作时间：{{detailModal.form.updated_at}}</p>
                    <p>备注：{{detailModal.form.status_instructe}}</p>
                  </div>
                  <div class="more text-center" v-if="detailModal.showApplyInfoAll" @click="detailModal.showApplyInfoAll = false">收起更多信息 <van-icon name="arrow-up" /></div>
                  <div class="more text-center" v-else @click="detailModal.showApplyInfoAll = true">展开更多信息 <van-icon name="arrow-down" /></div>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
          <van-cell-group>
            <van-cell title="订单信息" size="large" />
            <van-cell v-for="(item, index) in orderList.showData" :key="index">
              <template #title>
                <div class="clearfix order_info">
                  <span class="sn">订单编号：{{item.order_sn}}</span>
                  <van-tag v-if="item.type == 1" color="#999" text-color="#999" round plain type="primary">课程订单</van-tag>
                  <van-tag v-if="item.type == 2" color="#999" text-color="#999" round plain type="primary">会员卡订单</van-tag>
                </div>
                <div class="info clearfix">
                  <span>数量：{{item.goods_count}}</span>
                  <span>价格：¥ {{item.total_amount}}</span>
                  <span>
                    优惠：
                    <span v-if="item.discount_amount == 0">-</span>
                    <span v-else>¥ {{ item.discount_amount }} </span>
                  </span>
                  <span v-if="customer == false">
                    客服减免：
                    <span v-if="item.reduce_amount == 0">-</span>
                    <span v-else>¥ {{ item.reduce_amount }}</span>
                  </span>
                  <span class="float-right" style="color:#666;">实付：¥ {{ item.order_amount }}</span>
                </div>
              </template>
            </van-cell>
            <van-cell v-if="orderList.data.length > 3">
              <template #title>
                <div class="more text-center" v-if="detailModal.showOrderInfoAll" @click="hideMoreOrder">收起更多信息 <van-icon name="arrow-up" /></div>
                <div class="more text-center" v-else @click="showMoreOrder">展开更多信息 <van-icon name="arrow-down" /></div>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
      </div>
    </van-popup>
    <!--<Overlay :isLoad="ticketLoading"></Overlay>-->
    <Overlay :isLoad="ticketLoading" :customStyle="{top: '60px'}"></Overlay>
  </div>
</template>

<script>
import { tableConfigBase } from 'utils/common.js'
import { getInvoiceList, changeInvoice, cancelInvoice } from 'api/invoice/list'
import { getinvoiceOrderList } from 'api/invoice/orderList'
import { getOrderList } from 'api/invoice/orderList'
import { GetUserState } from 'api/user/auth/login'
import { showConfirmMessageBox, showMessage } from 'api/base/mobile/message'
import LoadList from "components/mobile/common/LoadList"
import Overlay from 'components/mobile/common/Overlay'
export default {
  components: {
    LoadList,
    Overlay
  },
  data() {
    return {
      ticketList: { //表格数据
        config: tableConfigBase(),
        data: [],
        selectedRows: [],
        pager:{},
        searchForm:{},
        form: {
          id: '',
          status: ''
        },
        loading: true,
      },
      ticketLoading:true,
      customer:false,
      disabledDel: true,
      orderList: {
        config: tableConfigBase(),
        selectedRows: [],
        data:[],
        showData: [],
      },
      detailModal: {
        visible: false,
        showApplyInfoAll: false,
        showOrderInfoAll: false,
        form: {
          id: '',
          uuid: '',
          owner_id: '',
          type: '0',
          money: '',
          title: '',
          taxpayer_num: '',
          taxpayer_addr: '',
          taxpayer_phone: '',
          account_bank: '',
          account_num: '',
          post_addr: '',
          email_addr: '',
          medium: '0',
          created_at: '',
          status: '0',
          status_instructe: '',
          updated_at: '',
          express_company:'',
          express_num:'',
          addressee:'',
          reci_phone:''
        },
        orderList: {
          data: []
        },
      },
      form:{
        owner_id : ''
      },
      user:{
        user_id: null
      },
      loading_data: false,
    }
  },
  mounted() {
    this.$emit('update:isShowHeader', false);
    this.ticketList.pager = {
        currentPage: 0,
        pageSize: 10,
        total: 0,
    }
    this.getOwner()
//    this.$emit('update:isShowOverlay', true);
  },
  methods: {
    initPopContent() {
      this.detailModal.showOrderInfoAll = false
      this.detailModal.showApplyInfoAll = false
    },
    hideMoreOrder() {
      this.orderList.showData = this.orderList.data.slice(0,3)
      this.detailModal.showOrderInfoAll = false
    },
    showMoreOrder() {
      this.orderList.showData = this.orderList.data
      this.detailModal.showOrderInfoAll = true
    },
    getOwner(){
      const that = this;
      GetUserState().then((res) => {
        if (res.id) {
          this.user.user_id = res.id
          var owner_id = this.user.user_id
          this.form.owner_id = owner_id
          that.getData();
        }else {
          this.form.owner_id = 'NO-USER'
          that.getData();
        }
      })
    },
    getData() {
      if (this.loading_data){
            return false;
      }
      this.loading_data = true;
      var data = {'owner_id' : this.form.owner_id}
      data['offset'] = (this.ticketList.pager.currentPage) * this.ticketList.pager.pageSize
      data['limit'] = this.ticketList.pager.pageSize

      const that = this
      getInvoiceList(data).then((res) => {
        var data = res.data
        var total = res.total
        that.ticketList.data.push(...data)
        that.ticketList.pager.total = total
        that.ticketList.loading = false
        that.loading_data = false

        this.ticketLoading = false
//        this.$emit('update:isShowOverlay', false);
      })
    },
    showInvoice(row) {
      this.detailModal.visible = true
      this.detailModal.form = {
        id: row.id,
        type :  row.type,
        medium : row.medium,
        money : row.money,
        title : row.title,
        company : row.company,
        taxpayer_num : row.taxpayer_num,
        taxpayer_addr : row.taxpayer_addr,
        taxpayer_phone: row.taxpayer_phone,
        account_bank : row.account_bank,
        account_num : row.account_num,
        post_addr_str : row.position_str,
        email_addr : row.email_addr,
        created_at : row.created_at,
        status : row.status,
        express_company : row.express_company,
        express_num : row.express_num,
        updated_at : row.updated_at,
        status_instructe: row.status_instructe,
        reci_phone: row.reci_phone,
        addressee: row.addressee,
      }
      var orderlist = row.order_uuids
      getOrderList(orderlist).then((res) => {
        this.orderList.data = res.data

        this.orderList.showData = res.data.length > 3 ? this.orderList.data.slice(0, 3) : this.orderList.data

        let cus = res.customer
        if (cus === 0){
            this.customer = true
        }
        this.ticketLoading = false
//        this.$emit('update:isShowOverlay', false);
      })
    },
//    修改
    updateInvoice(row) {
      this.goPath({path:"/mobile/center/ticket/apply",
                   query:{uuid: row.uuid}
      })
    },
//    点开详情右上角-取消
    changeInvoices() {
      showConfirmMessageBox('确定要取消这条开票吗？')
        .then(() => {
          const that = this
          var invoice_id = that.detailModal.form.id
          var values = {
            status: '1',
          }
          changeInvoice(invoice_id, values).then(() => {
            this.detailModal.visible = false
            for(var i=0;i<this.ticketList.data.length;i++){
              if (invoice_id == this.ticketList.data[i]['id']){
                  this.ticketList.data[i]['status'] = '1'
              }
            }
            this.ticketLoading = false
//            this.$emit('update:isShowOverlay', false);
          })
        })
    },
//    外部list处-取消
    changesInvoice(row) {
      showConfirmMessageBox('确定要取消开票吗？').then(() => {
        var invoice_id = row.id
        var values = {
            status : '1',
        }
        changeInvoice(invoice_id, values).then(() => {
          this.detailModal.visible = false
          for(var i=0;i<this.ticketList.data.length;i++){
              if (invoice_id == this.ticketList.data[i]['id']){
                  this.ticketList.data[i]['status'] = '1'
              }
          }
          this.ticketLoading = false
//          this.$emit('update:isShowOverlay', false);
        })
      })
    },
    getinvoicePager(pager) { //获取分页变化后数据
      this.ticketList.pager = pager
      this.getData()
      },
    goPath(path) {
        this.$router.push(path);
      },
    handleCommand(command) {  //批量操作
      if(command === 'change') {
        var rows = [];
        for(var i=0; i < this.ticketList.selectedRows.length; i++){
          rows.push(this.ticketList.selectedRows[i].id)
        }
        this.cancelInvoices(rows.join(','))
      }
    },
    handleSelectionChange(val){
      this.ticketList.selectedRows = val;
      if (this.ticketList.selectedRows.length == 0) {
          this.disabledDel = true
      }
      else {
        this.disabledDel = false
        for(var i = 0; i < this.ticketList.selectedRows.length; i++){
          if(this.ticketList.selectedRows[i].status != 0){
            this.disabledDel = true
            break
          }
        }
      }
    },
    //    批量取消
    cancelInvoices(cancel_id) {
      showConfirmMessageBox('确定要取消选中的开票吗？').then(() => {
        var invoice_id = cancel_id
        cancelInvoice({id:invoice_id}).then(() => {
          this.getData();
        })
      })
    },
    closeInvoice() {
      this.detailModal.visible = false
      this.getData()
      this.customer = false
    },
    close_dialog() {
      this.detailModal.visible = false
      this.getData()
      this.customer = false
    }
  },
}
</script>


<style lang="scss" scoped>
  .container {
    padding:10px 0 0 0;
  }
  .list {
    margin-bottom:10px;
    .content {
      padding-top:5px;
      display: flex;
      .left {
        flex:1;
        .type {
            font-size:16px;
            color:#333;
            margin-right:10px;
        }
        .van-tag {
          padding:2px 10px;
        }
      }
      .right {
        font-size:21px;
        color:#333;
      }
    }
    .status {
      font-size:14px;
      color:var(--van-primary-color);
      > button, > span {
        vertical-align: middle;
        margin-left:10px;
      }
    }
  }
  .sheet_common {
    .sheet_wrap {
      .sheet_content {
        padding:10px 0;
        .van-cell-group {
          margin-bottom:10px;
          .detail_content {
            p {
              margin-top:0;
              margin-bottom:5px;
              color:#666;
            }
          }
          .order_info {
            display: flex;
            align-items: center;
            margin-bottom:5px;
            .sn {
              flex: 1;
              color:#666;
            }
            .van-tag {
              padding:2px 10px;
            }
          }
          .info {
            > span {
              font-size:12px;
              margin-right:5px;
              color:#999;
            }
          }
        }
      }
    }
  }
  .more {
    font-size:12px;
    color:#999;
  }
  .overlay {
    top:60px;
  }
</style>
